import {
  getAgentDashboardInfo,
  getAgentDocuments,
  getAgentLeadDocuments,
  getAgentLeads,
  getAgentPayments,
  getAgentRefName,
  getFilteredAgents,
} from '../api/AgentsApi';
import useBaseQuery from '../hooks/useBaseQuery';
import {
  AgentDashboardResponse,
  AgentLeads,
  IBaseQueryOptions,
  LeadPaymentResponse,
  PaymentParams,
  AdminFilters,
  FilteredAgents,
} from '../types';
import IQueryKeys from '../types/IQueryKeys';

export const useFilteredAgents = (params: AdminFilters) => {
  return useBaseQuery<FilteredAgents>(
    [IQueryKeys.agentsKey, params],
    () => getFilteredAgents(params),
    {},
  );
};

export const useAgentsLeadsQuery = (
  id: string,
  options?: IBaseQueryOptions<AgentLeads>,
  leadName?: string,
) => {
  return useBaseQuery([IQueryKeys.agentLeads, id, leadName], () => getAgentLeads(id, leadName), {
    ...options,
  });
};

export const useAgentRefNameQuery = () => {
  return useBaseQuery([IQueryKeys.agentRefName], () => getAgentRefName());
};

export const useAgentPayments = (
  params: PaymentParams,
  options?: IBaseQueryOptions<LeadPaymentResponse>,
) => {
  return useBaseQuery([IQueryKeys.agentPayments, params], () => getAgentPayments(params), {
    ...options,
  });
};

export const useAgentLeadsDocuments = (agentLeadId: number) => {
  return useBaseQuery([IQueryKeys.agentLeadDocuments, agentLeadId], () =>
    getAgentLeadDocuments(agentLeadId),
  );
};

export const useAgentDocuments = (agentId: string) => {
  return useBaseQuery([IQueryKeys.agentDocuments, agentId], () => getAgentDocuments(agentId));
};

export const useAgentDashboard = (
  agentId: string,
  options?: IBaseQueryOptions<AgentDashboardResponse>,
) => {
  return useBaseQuery([IQueryKeys.agentDashboard, agentId], () => getAgentDashboardInfo(agentId), {
    ...options,
  });
};
